import { render, staticRenderFns } from "./SubunidadesCargadas.vue?vue&type=template&id=f1c968ce"
import script from "./SubunidadesCargadas.vue?vue&type=script&lang=js"
export * from "./SubunidadesCargadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c968ce')) {
      api.createRecord('f1c968ce', component.options)
    } else {
      api.reload('f1c968ce', component.options)
    }
    module.hot.accept("./SubunidadesCargadas.vue?vue&type=template&id=f1c968ce", function () {
      api.rerender('f1c968ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/SubunidadesCargadas.vue"
export default component.exports